$('.search-wrapper').click(function(){
    // console.log('here');
    $(this).find('input').toggleClass('hidden');
});

$('.Search__Close').click(function(){
    $('.search-wrapper').find('input').removeClass('hidden');
});

$('.currency-picker__btn').click(function(){
    $('#CurrencyModal').toggleClass('modal--is-active');
});

$('.currency-options__btn').click(function(){
    $('.currency-picker .currency-flag').attr('data-flag', $(this).attr('data-value'));
    $('.currency-picker .currency-picker__label').html($(this).attr('data-value'));
    $('.currency-options__btn.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    $('#CurrencyModal').removeClass('modal--is-active');
});

$('.currency-picker .currency-flag').attr('data-flag', $('.CurrencySelector__Select ').val());
$('.currency-picker .currency-picker__label').html($('.CurrencySelector__Select ').val());
$('.currency-options__btn.is-active').removeClass('is-active');
$('button[data-value=' + $('.CurrencySelector__Select ').val() + ']').addClass('is-active');

$('#CurrencyModal .modal__close').click(function(){
    $('#CurrencyModal').removeClass('modal--is-active');
});

$(document).on('change', '.ColorSwatch__Radio', function(e){
   if($('.Size__SelectedValue').html() == 'Size') {
       e.preventDefault();
       e.stopPropagation();
       $('.Color__SelectedValue').html($(this).val());    
   } else {
        $('#BIS_trigger').css('opacity', 1);
        $('#BIS_trigger').css('position', 'relative');
   }
});

$('.event-section .section-content').css('height', $('.event-section .img-wrapper').height());

$('.event-textarea').val("RSVP");

$('.btn-rsvp').click(function(e){
    e.preventDefault();
    $('.rsvp-modal').addClass('modal--is-active'); 
});

$('.rsvp-modal .modal__close').click(function(){
    $('.rsvp-modal').removeClass('modal--is-active');
});

var _className = '';
if($(window).width() > 768){
  _className = 'mobile__hide';
}
else {
  _className = 'desktop__hide';
}

$('.is-visible .image-container.'+_className).lightSlider({
    gallery:false,
    item: 1,
    slideMargin: 0,
    speed:500,
    auto:false,
    loop:true,
    pager: true,
    slideMargin: 1,
    enableDrag: true,
    prevHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg>',
    nextHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
    onSliderLoad: function() {
      $('.is-visible .image-container.'+_className).removeClass('image-container');
    },
    onBeforeSlide: function(a, b) {
      change_behind_img(b);
	}
});

$(document).on('click', '.events-title li', function(e){
    const target = $(this);
    const eventContent = $('.events-item-content-' + target.data('id'));
    target.parent().find('.is-active').removeClass('is-active');
    target.addClass('is-active');
    $('.events-item-content').removeClass('is-visible');
    eventContent.addClass('is-visible');
    eventContent.find('.image-container.'+_className).lightSlider({
        gallery:false,
        item: 1,
        slideMargin: 0,
        speed:500,
        auto:false,
        loop:true,
        pager: true,
        slideMargin: 1,
        enableDrag: true,
        prevHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg>',
        nextHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
        onSliderLoad: function() {
          $('.is-visible .image-container.'+_className).removeClass('image-container');
        },
        onBeforeSlide: function(a, b) {
          change_behind_img(b);
        } 
    });
});


function change_behind_img(idx) {
  var prev_index = idx % 2;
  var _index = (prev_index + 1) % 2;
  var _content = $(".events-item-content.is-visible");
  _content.find('.behind-img').find('.behind-img-'+prev_index).fadeOut(200, function(){
  	$(this).removeClass('is-visible');
    _content.find('.behind-img').find('.behind-img-'+_index).fadeIn(200).addClass('is-visible');
  })
  
}


$(document).on('click', '.Footer__Block--links .Footer__Title' , function(e){
    $(this).next().slideToggle();
});

$(document).on("click", ".Footer__Title.Heading", function(){
    $(this).toggleClass("open");
})
// The "Filter By" button shows wherever the filter sidebar is hidden, which is below 1008px (tablets too).
$(document).on("click", ".filter_by-open", function(){
    if(window.matchMedia("(max-width: 1007px)").matches) {
        $("html").addClass("no-scroll");
        $(".PageOverlay").addClass("is-visible");
        $("#collection-filter-drawer").attr("aria-hidden", "false");
    }
})
// Only the filter drawer is opened by hand (above). The menu and cart drawers are closed by the theme's Drawer, which
// already hides the overlay, so this must not run for them: toggling here turned the overlay back on after their X.
$(document).on("click", '.Drawer__Close[data-drawer-id="collection-filter-drawer"]', function(){
    $("#collection-filter-drawer").attr("aria-hidden", "true");
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
})
$(document).on("click", ".PageOverlay", function(){
    $("#collection-filter-drawer").attr("aria-hidden", "true");
    $(this).removeClass("is-visible");
    $("html").removeClass("no-scroll");
})
// Close the menu through its own close button so the theme's Drawer also releases the scroll lock and knows it is
// closed (hiding it by hand left the hamburger unable to reopen it).
$(document).on("click", ".SidebarMenu__CurrencySelector", function(){
    var closeButton = document.querySelector('#sidebar-menu [data-action="close-drawer"]');

    if (closeButton) {
        closeButton.click();
    }
})

// On desktop, product option lists (size, colour) open as a fixed-position dropdown under their button. The page can
// still scroll while one is open (rahul.css overrides .no-scroll), so the list would stay put and float over the
// Add to Cart buttons. Close it once the page scrolls, and on Escape wherever the focus is.
var optionListScrollStart = null;

function closeOpenOptionLists() {
    $('.OptionSelector[aria-hidden="false"] [data-action="close-popover"]').each(function(){
        this.click();
    });
}

$(document).on('click', '.ProductForm__Item[aria-controls]', function(){
    optionListScrollStart = window.pageYOffset;
});

$(window).on('scroll', function(){
    if (optionListScrollStart === null || !window.matchMedia('(min-width: 1008px)').matches) {
        return;
    }

    if (Math.abs(window.pageYOffset - optionListScrollStart) > 10) {
        optionListScrollStart = null;
        closeOpenOptionLists();
    }
});

$(document).on('keydown', function(e){
    if (e.key === 'Escape') {
        closeOpenOptionLists();
    }
});